import Acmf from './acmf'
import Admin from './admin'
import Analytic from './analytic'
import AnalyticManagement from './analyticManagement'
import AirlineManagement from './airlineManagement'
import AnalyticComparison from './analyticComparison'
import AnalyticModule from './analyticModule'
import Attachments from './attachments'
import BlobTransfer from './blobTransfer'
import Connectivity from './connectivity'
import CustomAlert from './customalert'
import Dplf from './dplf'
import FeatureFlag from './featureFlag'
import Filter from './filter'
import Fleet from './fleet'
import Flightaware from './flightaware'
import Fullflight from './fullflight'
import Lookup from './lookup'
import MaintenanceIssues from './maintenanceIssues'
import Plot from './plot'
import Plotly from './plotly'
import User from './user'
import Removals from './removal'
import Discussion from './discussion'
import FaultMessages from './faultMessage'
import Selections from './selections'
import PhmAlerts from './phmAlerts'
import Feature from './feature'
import AlertType from './alertType'
import IssueType from './issueType'
import UserGuide from './userGuide'
import FlightPhase from './flightPhase'
import SubscriptionCenter from './subscriptionCenter'
import StatusUpdates from './statusUpdates'
import DerivedParameters from './derivedParameter'
import PowerBi from './powerBi'
import AnserTool from './anserTool'
import RoleManagement from './roleManagement'

export default {
  acmf: new Acmf(),
  admin: new Admin(),
  airlineManagement: new AirlineManagement(),
  alertType: new AlertType(),
  analytic: new Analytic(),
  analyticComparison: new AnalyticComparison(),
  analyticManagement: new AnalyticManagement(),
  analyticModule: new AnalyticModule(),
  anserTool: new AnserTool(),
  attachments: new Attachments(),
  blobTransfer: new BlobTransfer(),
  connectivity: new Connectivity(),
  customalert: new CustomAlert(),
  derivedParameters: new DerivedParameters(),
  discussion: new Discussion(),
  dplf: new Dplf(),
  faultMessages: new FaultMessages(),
  feature: new Feature(),
  featureFlag: new FeatureFlag(),
  filter: new Filter(),
  fleet: new Fleet(),
  flightaware: new Flightaware(),
  flightPhase: new FlightPhase(),
  fullflight: new Fullflight(),
  issueType: new IssueType(),
  lookup: new Lookup(),
  maintenanceIssues: new MaintenanceIssues(),
  phmAlerts: new PhmAlerts(),
  plot: new Plot(),
  plotly: new Plotly(),
  powerBi: new PowerBi(),
  removals: new Removals(),
  roleManagement: new RoleManagement(),
  selections: new Selections(),
  statusUpdates: new StatusUpdates(),
  subscriptionCenter: new SubscriptionCenter(),
  user: new User(),
  userGuide: new UserGuide(),
}
